module.exports = __webpack_public_path__ + "00603bdb45d281db50dd81308cac1b7f.svg";